const EXPIRY_TIME_MS = 10 * 60 * 1000; // 10 dakika

interface StoredDataWithTimestamp {
  data: any;
  timestamp: number;
}

/**
 * localStorage'e timestamp ile birlikte veri kaydeder
 */
export const setItemWithExpiry = (key: string, value: any): void => {
  if (typeof window === 'undefined') return;

  const item: StoredDataWithTimestamp = {
    data: value,
    timestamp: Date.now(),
  };

  localStorage.setItem(key, JSON.stringify(item));
};

/**
 * localStorage'den timestamp kontrolü yaparak veri okur
 * Eğer veri 10 dakikadan eskiyse siler ve null döner
 */
export const getItemWithExpiry = <T = any>(key: string): T | null => {
  if (typeof window === 'undefined') return null;

  try {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item: StoredDataWithTimestamp = JSON.parse(itemStr);

    // Timestamp kontrolü
    if (Date.now() - item.timestamp > EXPIRY_TIME_MS) {
      // Veri süresi dolmuş, sil
      localStorage.removeItem(key);
      return null;
    }

    return item.data as T;
  } catch (error) {
    console.error(`Error reading ${key} from localStorage:`, error);
    // Hatalı veri varsa sil
    localStorage.removeItem(key);
    return null;
  }
};

/**
 * localStorage'den veriyi siler
 */
export const removeItem = (key: string): void => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(key);
};
